import { GetState } from "base/src/store/baseStore";

export function IsDebug () {
    return process.env.NODE_ENV !== 'production';
}

export function IsTest () {
    return process.env.NODE_ENV === "test";
}

export function IsStorybook () {
    return IsDebug() && Boolean(typeof window !== 'undefined' && window.location.href.includes('http://localhost:6006'));
}


export function IsDevSimulate () {
    if(IsDebug() == false) { return false }
    return GetState().UtilReducer.DevSimulate
}
